mainHandler = {
    $hidePopup: $('.popup-header'),
    $popupContainer: $('.popup-container'),

    initGPDRConsent: function() {
        var self = this;
        if (this.$popupContainer.length > 0) {
            // if user has accepted coookie consent before, no need to do anyting
            var $cookieConsentContainer = $('#cookie-law-info-bar');
            if ($cookieConsentContainer.is(":visible")) {
                this.$popupContainer.css('bottom', $cookieConsentContainer.outerHeight());
                $cookieConsentContainer.find('a[role="button"]').on('click', function() {
                    self.$popupContainer.css('bottom', 0);
                });
            }
            $('.footer-inner').addClass('with-popup');
        }
    },

    externalLinkCheck = function() {
        $('a').each(function() {
            $iconLink = $(this);
            var href = this.hostname;

            if (href != window.location.host) {
                var externalLink = $(this).data('external-link');

                if ($iconLink.hasClass('animate-icon') && externalLink) {
                    var color = $iconLink.css('color');
                    var $cloned = $iconLink.clone();

                    var $span = document.createElement('span');
                    var $iconSpan = document.createElement('span');

                    $span.className = 'animate-icon-span';
                    $iconSpan.className = 'icon-span icon-external-link-left';

                    $($iconSpan).css({
                        'color' : color
                    });

                    $($span).append($iconSpan);
                    $($span).append($cloned);
                    
                    $iconLink.replaceWith($span);
                    
                } else if (externalLink) {
                    $iconLink.addClass('link-with-icon-left icon-external-link-left');
                }

            }

        });
    },

    autoOpenNewTabLinks: function() {
        var $externalLinksContainer = $('.external-new-tab');
        if ($externalLinksContainer.length > 0) {
            $externalLinksContainer.find('a').attr('target', '_blank');
        }
    },

    init = function() {
        var self = this;

        this.$hidePopup.on('click', function(e) {
            e.preventDefault();
            self.$popupContainer.toggleClass('closed');
            if (self.$popupContainer.is('.closed')) {
                self.$popupContainer.find('.hide-popup')
                    .removeClass('icon-chevron-down-right')
                    .addClass('icon-chevron-up-right');
            } else {
                self.$popupContainer.find('.hide-popup')
                    .removeClass('icon-chevron-up-right')
                    .addClass('icon-chevron-down-right');
            }
        });

        this.initGPDRConsent();
        this.autoOpenNewTabLinks();
        this.externalLinkCheck();
        $('main').css('margin-top', $('header').outerHeight());
        if (location.hash) {
            var hash = location.hash.replace('#', '');
            menuNavHandler.scrollToInternal(hash);
        }
    }
}